<template>
  <router-view></router-view>
</template>

<script>
import { mapState } from 'vuex'
import { notNeedCompanyRouteName } from '@/utils/config'
export default {
  name: 'IntroduceLayout',
  computed: {
    ...mapState('user', ['isLogin', 'userInfo', 'openedProducts']),
    code() {
      return this.$route.meta?.code
    },
    routeName() {
      return this.$route.name
    }
  },

  watch: {
    $route: {
      handler(value) {
        if (value && this.openedProducts) {
          this.showDialog()
        }
      },
      deep: true,
      immediate: true
    },
    openedProducts: {
      handler() {
        this.showDialog()
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    getDialogInfo() {
      const { isLogin, userInfo, openedProducts, code, routeName } = this

      // 未登录
      if (!isLogin || !userInfo.userId) return
      // 不需要认证
      if (notNeedCompanyRouteName.includes(routeName)) return

      const { companyName, companyStatus, companyEnable } = userInfo

      // 未提交认证申请
      if (!companyName)
        return {
          title: '提示',
          msg: '您不属于企业用户，请加入或认证企业',
          confirmButtonText: '前往',
          type: 'noCompany'
        }
      // 认证中
      if (companyStatus === 0)
        return {
          title: '提示',
          msg: '请等审核通过后即可使用',
          confirmButtonText: '查看详情',
          type: 'waitCompany'
        }

      // 驳回认证
      if (companyStatus === 10)
        return {
          title: '提示',
          msg: '认证审核未通过',
          confirmButtonText: '前往',
          type: 'failCompany'
        }

      // 企业被禁用
      if (companyStatus === 20 && companyEnable === -1)
        return {
          title: '提示',
          msg: '您的企业已被禁用，请联系客服解除禁用',
          confirmButtonText: '确定',
          showCancelButton: false
        }

      // 开通
      if (code && openedProducts[code] !== '已开通') {
        return {
          title: '提示',
          msg: '该产品尚未开通',
          confirmButtonText: '去开通',
          type: 'noProduct'
        }
      }
    },

    async showDialog() {
      const info = this.getDialogInfo()
      if (!info) return
      const { title, msg, confirmButtonText, type, showCancelButton } = info
      const flag = await this.$confirm(msg, title, {
        confirmButtonText,
        cancelButtonText: '取消',
        showCancelButton: showCancelButton ?? true,
        type: 'warning'
      })

      if (flag !== 'confirm') return
      let href = ''
      switch (type) {
        case 'noCompany':
          href = '/user/company/certification'
          break
        case 'failCompany':
          href = '/user/company/certification'
          break
        case 'waitCompany':
          href = '/user/company/certification'
          break
        case 'noProduct':
          href = '/user/product'
          break
      }
      href && (location.href = href)
    }
  }
}
</script>

<style lang="scss" scoped></style>
